/* eslint-disable react/style-prop-object */
import React from "react";

import Crystal from "../../assets/demenu_crystals_left.svg";

import CloseIcon from '@mui/icons-material/Close';
import { Divider } from "@mui/material";

export default function LeandingPageHeader({ open, setOpen }) {
    const handleclose = () => {
        setOpen(!open);
    }
    return (
        <>
            <div className="relative" onClick={() => setOpen(false)}>
                <div className={`fixed block top-0 right-0 space-y-10 md:space-y-0 w-full max-w-[800px] overflow-x-hidden h-screen bg-light-black z-50 overflow-y-auto ${open ? 'drawer-animation' : 'drawer-animation-close'} transition-all duration-200`}>
                    <div className="flex align-middle justify-between px-10">
                        <h2 className="text-white text-4xl mb-4 md:mb-24 pt-6">
                            DeGods Ecosystem
                        </h2>
                        <span className="text-white text-4xl mb-24 pt-6 cursor-pointer" onClick={handleclose} >
                            <CloseIcon />
                        </span>
                    </div>
                    <div className="flex flex-col md:flex-row items-start pb-10 px-10">
                        <div className="flex-1 flex flex-col space-y-6">
                            <h2 className="mb-6 text-white text-xl">Stake & Earn $DUST</h2>
                            <div className="transition-all duration-200 hover:scale-105">
                                <p className="text-yellow">Stake DeadGods</p>
                                <p className="text-black-text">Earn $DUST by staking your DeadGod</p>
                            </div>
                            <div className="transition-all duration-200 hover:scale-105">
                                <p className="text-yellow">Stake DeGods</p>
                                <p className="text-black-text">Earn $DUST by staking your DeGod</p>
                            </div>
                            <div className="pb-16">
                                <p className="text-yellow">Welcome Bot</p>
                                <p className="text-black-text">Earn $DUST by welcome DeGods</p>
                            </div>
                            <h2 className="mb-6 text-white text-xl">Stake & Earn $DUST</h2>
                            <div className="transition-all duration-200 hover:scale-105">
                                <p className="text-yellow">Transcend your DeGods</p>
                                <p className="text-black-text">Spend $Dust to convert to a DeadGod</p>
                            </div>
                            <div className="transition-all duration-200 hover:scale-105">
                                <p className="text-yellow">Dusties Store</p>
                                <p className="text-black-text">Spend $Dust on raffles and auctions</p>
                            </div>
                        </div>
                        <Divider />
                        <div className="flex-1 flex flex-col space-y-6">
                            <h2 className="mb-6 text-white text-xl">Learn About DeGods</h2>
                            <div className="transition-all duration-200 hover:scale-105">
                                <p className="text-yellow">Road Map</p>
                                <p className="text-black-text">Learn whats coming up for DeGods</p>
                            </div>
                            <div className="transition-all duration-200 hover:scale-105">
                                <p className="text-yellow">Degods Documentation</p>
                                <p className="text-black-text">All you need to know about DeGods</p>
                            </div>
                            <div className="pb-16">
                                <p className="text-yellow">$DUST Documentation</p>
                                <p className="text-black-text">All you need to know about $DUST</p>
                            </div>
                            <h2 className="mb-6 text-white text-xl">Tools</h2>
                            <div className="transition-all duration-200 hover:scale-105">
                                <p className="text-yellow">Rarity Tool</p>
                                <p className="text-black-text">Check your DeGod/Deadgod rarity</p>
                            </div>
                            <div className="transition-all duration-200 hover:scale-105">
                                <p className="text-yellow">DeMap</p>
                                <p className="text-black-text">Add your DeGods location on a map</p>
                            </div>
                        </div>
                    </div>
                    <img src={Crystal} alt="" className="px-10" />
                </div>
            </div>
        </>
    )
}
